/*
 * @Author: shisan
 * @Date: 2019-07-11 20:04:31
 * @Last Modified by: shisan
 * @Last Modified time: 2020-01-16 14:20:52
 */

import originJsonp from 'jsonp'

export default function jsonp(url, data, option) {
  const realUrl = url + (url.indexOf('?') < 0 ? '?' : '&') + param(data)

  const startTime = Date.now()

  return new Promise((resolve, reject) => {
    originJsonp(realUrl, option, (err, res) => {
      if (process.env.NODE_ENV !== 'production') {
        // console.log('接口:', url)
        // console.log('参数:', data)
        // console.log('结果:', res)
        // console.log('▁▁▁▁▁▁▁▁▁▁')
      }

      if (!err && (res.code === 200 || res.status === 200 || res.code === 0)) {
        resolve(res.data)
      } else {
        reject(res)
      }
    })
  })
}

function param(data) {
  let url = ''
  for (var k in data) {
    let value = data[k] !== undefined ? data[k] : ''
    url += '&' + k + '=' + encodeURIComponent(value)
  }
  return url ? url.substring(1) : ''
}
